import React from "react";
import Cartlist from "../cart/Cartlist";
import Cartstatus from "../cart/Cartstatus";

function Cartitems(props) {  
  
  return (

    <div className="cartmain_l customscroll">
        <div className="cartlist">          
          {props.cartItems.length > 0 && props.cartItems.map((item, index) => (            
            <Cartlist 
            key={index} 
            updateItem={props.updateItem}
            deleteItem={props.deleteItem}
            cartLoad={props.cartLoad}
            {...item}
            />
          ))}
      </div>

  <Cartstatus />

    </div>
    );
}

export default Cartitems;
